module.exports = __webpack_public_path__ + "static/media/home.1d4ed576.png";